import { CouponIssueRecord } from '@/types/coupon';
import { CouponItem, isExpired, checkThreshold, generateCouponSubname } from './common';
import { MemberCardInfo } from '@/types/member-card';

export type { CouponItem };

/**
 * 生成会员卡代金券列表
 * @param memberCardData 会员卡数据
 * @param couponList 用户可用的会员卡代金券列表
 * @param nowTime 当前时间
 * @returns 代金券列表
 */
export function createMemberCardCoupons(
  memberCardData: MemberCardInfo | undefined,
  couponList: CouponIssueRecord[],
  nowTime: string,
): CouponItem[] {
  // 如果用户没有优惠券，则返回空
  if (!couponList?.length) {
    return [];
  }

  // 过滤出未使用过的券
  const list = couponList.filter((item) => item.is_used !== 1);

  return list.map((coupon) => {
    // 判断优惠券是否可用
    let disabled = false;

    // 1. 检查优惠券是否过期
    if (isExpired(coupon.validity_end, nowTime)) {
      disabled = true;
    }

    if (memberCardData?.member_card_type_id) {
      // 如果当前有选择会员卡，则判断代金券是否适用当前会员卡类型
      // 判断代金券是否适用当前会员卡类型
      if (
        coupon.member_card_type_id > 0 &&
        coupon.member_card_type_id !== memberCardData?.member_card_type_id
      ) {
        disabled = true;
      }

      // 3. 检查价格是否满足优惠券门槛（使用会员卡销售价）
      if (!checkThreshold(memberCardData.discount_price, coupon.threshold_price)) {
        disabled = true;
      }

      // 如果当前没有选择会员卡，则禁用所有优惠券
      if (!memberCardData?.member_card_type_id) {
        disabled = true;
      }
    } else {
      // 如果当前没有选择会员卡，则禁用所有优惠券
      disabled = true;
    }

    return {
      ...coupon,
      disabled,
      name: coupon.coupon_template_info?.name,
      subname: generateCouponSubname(coupon),
    };
  });
}
